// Number of columns in the wallet search grid.
// Used for both CSS grid layout and keyboard navigation.
export const WALLET_GRID_COLUMNS = 4;
